module.exports = __webpack_public_path__ + "static/add_google_calendars-e75e4ab5d71810a758ff98e126ec56fa.png";